import { AfterViewInit, Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../components/confirm.dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogConfig } from '../model';

@Directive({
    selector: '[pimConfirmDialog],pimConfirmDialog',
    standalone: false
})
export class ConfirmDialogDirective implements AfterViewInit, OnDestroy {
	@Output()
	confirmAction: EventEmitter<void> = new EventEmitter();

	@Output()
	cancelAction: EventEmitter<void> = new EventEmitter();

	@Output()
	saveAction: EventEmitter<void> = new EventEmitter();

	// tslint:disable-next-line:no-input-rename
	@Input('pimConfirmDialog')
	confirmDialogConfig!: ConfirmDialogConfig; // Keep any - string 'aliConfirmDialog' will be bound if no custom config is given

	private subscriptions: Subscription[] = [];

	constructor(private dialog: MatDialog) {
	}

	ngAfterViewInit(): void {
		if (!this.confirmDialogConfig) {
			this.confirmDialogConfig = new ConfirmDialogConfig();
		}
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub: Subscription) => {
			sub.unsubscribe();
		});
	}

	@HostListener('click', ['$event'])
	onClick(event?: any): void {
		event?.stopPropagation();
		if (this.confirmDialogConfig && !this.confirmDialogConfig.shouldOpen) {
			return;
		}
		this.openDialog();
	}

	openDialog(): any {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: this.confirmDialogConfig,
			width: '650px',
			maxWidth: '90vw'
		});
		this.setCloseHandler(dialogRef);
	}

	private setCloseHandler(dialogRef: MatDialogRef<ConfirmDialogComponent>): void {
		const closeSub = dialogRef.afterClosed().subscribe((result: any) => {
			if (result === 'true') {
				this.confirmAction.emit();
			} else if (result === 'save') {
				this.saveAction.emit();
			} else {
				this.cancelAction.emit();
			}
		});
		this.subscriptions.push(closeSub);
	}
}

